import { languageObject } from "assets/data/languages";
import { Langs } from "components";
import FeedLayout from "layouts/files/FeedLayout";
import { useDispatch, useSelector } from "react-redux";
import { addLang, removeLang } from "services/redux/settings/account";
import { AppDispatch, RootState } from "services/redux/store";
// import { customToaster } from "ui";

const Languages = () => {
    const selectedLanguages = useSelector(
        (state: RootState) => state.account.selectedLang
    );
    const dispatch = useDispatch<AppDispatch>();
    // toggle lang
    const toggleLang = (lang: languageObject) => {
        if (selectedLanguages.some((l) => l.code == lang.code)) {
            // customToaster("error", "You must select at least 1 topic", mode);
            dispatch(removeLang(lang));
        } else {
            dispatch(addLang(lang));
        }
    };
    return (
        <FeedLayout pageTitle="Settings">
            <Langs
                selectedLanguages={selectedLanguages}
                toggleLang={toggleLang}
                isPage
            />
        </FeedLayout>
    );
};

export default Languages;
